import React, { useState } from 'react';
import classes from './Bond.module.scss';

declare type IssuerType = {
  id: number;
  header: string;
  issuer: string;
  size: string;
  issueDate: string;
  maturity: string;
  coupon: string;
  inPayDate: string;
  rating?: string;
  govLaw: string;
  listing: string;
  isin: Array<{
    name: string;
    value: string;
  }>;
};

const issuers = [
  {
    id: 0,
    header: 'A. Senior Secured Floating Rate Notes due 2032',
    issuer: 'HSE Investment S.à r.l.',
    size: '€400,000,000',
    issueDate: '25 August 2025',
    maturity: '15 January 2032',
    coupon:
      '6M-EURIBOR (subject to a zero floor) plus 6,5% per annum',
    inPayDate:
      '30 June and 31 December of each year (commencing on December 31, 2026), except for last interest payment date, which will be 15 January 2032',
    rating: 'B- by Fitch and S&P',
    govLaw: 'New York',
    listing: 'The International Stock Exchange',
    isin: [
      { name: 'ISIN (Regulation S Notes)', value: 'XS3437716494' },
    ],
  },
  {
    id: 2,
    header: 'B: HoldCo Pik Notes due 2032',
    issuer: 'HSE Finance S.à r.l.',
    size: '€91,200,000',
    issueDate: 'August 25, 2025',
    maturity:
      '15 April 2032',
    coupon:
      '(i) PIK Interest equal to the sum of 6M-EURIBOR (subject to a zero floor) plus 7.85% per annum, reset semi-annually, plus (ii) cash interest at 0.50% per annum',
    inPayDate:
      '30 June and 31 December of each year (commencing on 31 December 2026, except for last interest payment date, which will be 15 April 2032)',
    // rating: 'B2 by Moody’s and B by S&P',
    govLaw: 'New York',
    listing: 'The International Stock Exchange',
    isin: [
      { name: 'ISIN (Regulation S Notes)', value: 'XS3084270480' },
    ],
  },
];

const Issuer = (props: { issuer: IssuerType }) => {
  return (
    <div className={classes.Issuer}>
      <table>
        <tbody>
          <tr>
            <td>Issuer</td>
            <td>{props.issuer.issuer}</td>
          </tr>
          <tr>
            <td>Size</td>
            <td>{props.issuer.size}</td>
          </tr>
          <tr>
            <td>Issue Date</td>
            <td>{props.issuer.issueDate}</td>
          </tr>
          <tr>
            <td>Maturity</td>
            <td>{props.issuer.maturity}</td>
          </tr>
          <tr>
            <td>Coupon</td>
            <td>{props.issuer.coupon}</td>
          </tr>
          <tr>
            <td>Interest payment dates</td>
            <td>{props.issuer.inPayDate}</td>
          </tr>
          <tr>
            <td>Governing law</td>
            <td>{props.issuer.govLaw}</td>
          </tr>
          <tr>
            {props.issuer?.rating && (
              <>
                <td>Rating*</td>
                <td>{props.issuer.rating}</td>
              </>
            )}
          </tr>
          <tr>
            <td>Listing</td>
            <td>{props.issuer.listing}</td>
          </tr>
          {props.issuer.isin.map((item, key) => (
            <tr key={key}>
              <td>{item.name}</td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const Toggle = (props: { issuer: IssuerType; changeHandler: any; currentTab: number }) => {
  return (
    <div
      className={[props.currentTab === props.issuer.id && classes.Active, classes.Toggle].join(' ')}
      onClick={() => props.changeHandler(props.issuer.id)}
    >
      {props.issuer.header}
    </div>
  );
};

const Bond = () => {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <div className={classes.Bond} id="bond">
      <h2>Bond</h2>
      <div className={classes.Toggles}>
        {issuers.map((issuer, key) => (
          <Toggle issuer={issuer} changeHandler={setCurrentTab} currentTab={currentTab} key={key} />
        ))}
      </div>
      <div className={classes.Body}>
        {issuers.map((issuer, key) => {
          return currentTab === issuer.id ? <Issuer issuer={issuer} key={key} /> : null;
        })}
        <p className={classes.Note}>
          Note: A securities rating is not a recommendation to buy, sell or hold securities and may
          be subject to revision or withdrawal at any time.
        </p>
      </div>
    </div>
  );
};

export default Bond;
